import React, { FC } from 'react';
import { Grow, Chip } from '@mui/material';
import { MaterialSymbol } from '@/components/MaterialSymbol';
import { M24MediaModel } from '@/declarations/models/M24MediaModel';
import { ChildrenProp } from '@/declarations/ChildrenProp';
import Container from '../../../../../components/Container';
import HeaderThumbnail from './HeaderThumbnail';
import HeaderTitle from './HeaderTitle';

export interface M24HeaderProps {
  open: boolean;
  item: M24MediaModel;
  siteId?: number;
}

export const M24Header: FC<M24HeaderProps & ChildrenProp> = ({ children, open = true, item, siteId }) => {
  const altText = item?.content?.alttext;
  let titlePrefix = '';
  if (item.type === 'video') {
    titlePrefix = 'VIDEO**: ';
  }
  if (item.type === 'audio') {
    titlePrefix = 'AUDIO**: ';
  }
  let source = 'm24';
  if (item.dmsf_id) {
    source = 'dams';
  }
  let sameSite = true;
  if (siteId && item.site_id && item.site_id !== siteId) {
    sameSite = false;
  }

  // console.log(item);
  return (
    <Container left fullWidth>
      <HeaderThumbnail item={item} hidden={open} alt={altText} />
      <Container column left fullWidth>
        <Container gap={1} left fullWidth>
          <Container left column gap={0.5}>
            {source === 'm24' && !sameSite && (
              <Chip
                size='small'
                sx={{ marginLeft: '0.5em', fontSize: '0.7em', backgroundColor: '#C44DBA', color: '#fff' }}
                label={`M24${sameSite ? '' : ` / ${item.site_name}`}`}
              />
            )}
            {source === 'dams' && (
              <Chip
                size='small'
                sx={{ marginLeft: '0.5em', fontSize: '0.7em', backgroundColor: '#785AAC', color: '#fff' }}
                label='DAMS'
              />
            )}

            <HeaderTitle title={`${titlePrefix}${item?.title || item.filename}`} />
          </Container>
          <Grow in={!open && !altText}>
            <MaterialSymbol name='error' fill color='error' />
          </Grow>
        </Container>
        <Container px={1}>{children}</Container>
      </Container>
    </Container>
  );
};

export default M24Header;
